import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { ChatMessage } from "../../types";
import styles from "./MessageBubble.module.css"; // Import CSS Modules
import CopyButton from "../common/CopyButton"; // Corrected import for default export
import FeedbackButtons from "./FeedbackButtons"; // Import FeedbackButtons
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
// import { useChatStore } from '../../store/chatStore'; // Removed unused import
import { formatTimestamp } from "../../utils/dateUtils"; // Import the new utility

interface MessageBubbleProps {
  message: ChatMessage;
  isAnalyzingUrl?: boolean;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ message, isAnalyzingUrl }) => {
  const isUser = message.sender === "user";

  // No longer need local handleCopy, CopyButton component handles its own logic

  const validDate = message.created_at
    ? new Date(message.created_at)
    : new Date();

  const renderContent = () => (
    <div
      className={`${styles.content} ${isUser ? styles.userContent : styles.aiContent}`}
    >
      <span
        className={`${styles.senderName} ${isUser ? styles.userSenderName : styles.aiSenderName}`}
      >
        {isUser ? "Tu" : "Asistent"}
      </span>
      {isUser || message.isLoading ? (
        message.displayContent || message.content
      ) : (
        <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
          {message.content}
        </ReactMarkdown>
      )}
      {message.isLoading && message.sender === "ai" && (
        <span className={styles.typingIndicator}>
          {isAnalyzingUrl
            ? "analizează URL..."
            : message.isThinking
              ? "Smartie gândește..."
              : "Gândește..."}
        </span>
      )}
    </div>
  );

  const renderActionButtons = () => {
    if (!isUser && !message.isLoading && message.content && message.id) {
      // Ensure message ID is string for feedback
      const messageIdStr = String(message.id);

      return (
        <div className={styles.actionsWrapper}>
          <FeedbackButtons messageId={messageIdStr} />
          <div className={styles.copyButtonWrapper}>
            <CopyButton
              textToCopy={message.content}
              getHtmlToCopy={() =>
                renderToStaticMarkup(
                  <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                    {message.content}
                  </ReactMarkdown>
                )
              }
              title="Copiază conținutul mesajului"
            />
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div
      className={`${styles.messageBubble} ${isUser ? styles.userBubble : styles.aiBubble}`}
    >
      {isUser ? (
        renderContent()
      ) : (
        <div className={styles.aiContentWrapper}>
          {message.plan && (
            <details className={styles.planDetails} open={false}>
              <summary className={styles.planSummary}>
                Vezi planul de raționament
              </summary>
              <div className={styles.planContent}>
                <ul>
                  {message.plan.steps.map((step, i) => (
                    <li key={i}>{step}</li>
                  ))}
                </ul>
              </div>
            </details>
          )}
          {renderContent()}
          {renderActionButtons()}
        </div>
      )}
      <span
        className={`${styles.timestamp} ${isUser ? styles.userTimestamp : styles.aiTimestamp}`}
      >
        {formatTimestamp(validDate)}
      </span>
    </div>
  );
};

export default MessageBubble;
